import React, { Component, ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import './Tools.scss';
import { ERouterPath } from '../../features/router/ERouterPath';
import { ApplicationState } from '../../app/store';
import { connect } from 'react-redux';
import { SingleUser } from '../../api/types';
import { Measurement } from '../../models/Measurement';
import { MeasurementSplitLayout } from './MeasurementSplitLayout';

interface ToolsProps extends RouteComponentProps {
  user?: SingleUser;
}

interface ToolsState {
  returnedByMeasurementSubmit?: boolean;
  returnedByMeasurementCreated?: boolean;
  loadingMeasurements: boolean;
  loadingMeasurementsError?: string;
}

export enum ToolsQueryState {
  MEASUREMENT_SUBMITTED = 'state=measurement_submitted',
  MEASUREMENT_CREATED = 'state=measurement_created'
}

class ToolsComponent extends Component<ToolsProps, ToolsState> {
  constructor(props: ToolsProps) {
    super(props);
    this.state = {
      returnedByMeasurementSubmit: this.isReturnedByMeasurementSubmit(this.props.location.search),
      returnedByMeasurementCreated: this.isReturnedByMeasurementCreated(this.props.location.search),
      loadingMeasurements: true,
    };
  }

  isReturnedByMeasurementSubmit(query: string): boolean {
    return query.includes(ToolsQueryState.MEASUREMENT_SUBMITTED);
  }

  isReturnedByMeasurementCreated(query: string): boolean {
    return query.includes(ToolsQueryState.MEASUREMENT_CREATED);
  }

  handleClick = (measurement: Measurement): void => {
    this.props.history.push(`${ERouterPath.measurement}?id=${measurement.id}`);
  };

  render(): ReactNode {
    const {
      returnedByMeasurementSubmit,
      returnedByMeasurementCreated } = this.state;

    return (
      <MeasurementSplitLayout>
        { returnedByMeasurementSubmit && <Alert className="tools__success-message" variant="success">Meting verstuurd!</Alert>}
        { returnedByMeasurementCreated && <Alert className="tools__success-message" variant="success">Nieuwe meting aangemaakt!</Alert>}
      </MeasurementSplitLayout>
    );
  }
}

export const Tools = connect((state: ApplicationState) => ({
  dossier: state.session.dossier,
  dossierRelation: state.session.relation,
  user: state.session.user,
}))(withRouter(ToolsComponent));
